// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-activator[data-v-51faad60] *{cursor:pointer}.select-activator[data-v-51faad60]  .inner-input{background-color:#fdfdfd;border:1px solid #d5dae1;padding-right:54px}.chevron-icon[data-v-51faad60]{fill:transparent;stroke:#0f2345;transform-origin:center;transition:transform .15s ease-out;width:19px;height:12px}.chevron-icon.open[data-v-51faad60]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
